import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules'
import useUser from 'shared/hooks/use-user'
import { WEBSITE_API } from '../api/website-api'
import { WebsiteListApiInterface } from '../types/website-interface'

export const useWebsites = () => {
  const { user } = useUser()

  const { revalidateModules } = useRevalidateModules()

  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.get, WebsiteListApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: websites, mutate } = useControlledSwr(
    () => user && [`${WEBSITE_API}/websites?page=1&itemsPerPage=50`, RequestModuleEnum.Websites],
    fetcher,
  )

  const revalidateWebsiteModule = async (hardRevalidate?: boolean) => {
    await revalidateModules([RequestModuleEnum.Websites], hardRevalidate)
  }

  return { websites, mutate, revalidateWebsiteModule, isFetching }
}
